import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

type SectionProps = {
    children: ReactNode
    id?: string
    className?: string
    containerClassName?: string
    /** Drops the horizontal container so a child can bleed to the viewport edge. */
    bleed?: boolean
    'aria-label'?: string
}

/**
 * Every section on the original site shares one rhythm: 160px of vertical
 * breathing room on desktop, 120px below that, inside a 1200px container.
 */
export const Section = ({
    children,
    id,
    className,
    containerClassName,
    bleed = false,
    ...rest
}: SectionProps) => {
    return (
        <section
            id={id}
            className={cn(
                'relative w-full overflow-hidden px-6 py-[120px] md:px-8 lg:px-16 lg:py-[160px]',
                className
            )}
            {...rest}
        >
            {bleed ? (
                children
            ) : (
                <div className={cn('relative z-1 mx-auto flex w-full max-w-[1200px] flex-col items-center', containerClassName)}>
                    {children}
                </div>
            )}
        </section>
    )
}
